import { typeOptions } from '../../constants/discount';

export const formatDate = (dateString: string) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options);
};

export const getDiscountCategoryLabel = (value: number) => {
  const option = typeOptions.find((opt) => opt.value === value);
  return option ? option.label : '';
};
